import { queryConstants } from '../_constants';

export function queries(state = {}, action) {
//	console.log('queries reducer was called with state', state, 'and action', action)
    switch (action.type) {
        case queryConstants.GET_QUERY_SUCCESS:
            return {items: action.queries};
        case queryConstants.GET_QUERY_REQUEST:
            return {isLoading: action.isLoading};
        case queryConstants.GET_QUERY_FAILURE:
            return {hasErrored: action.hasErrored};

        case queryConstants.GET_ACTIVE_QUERY_SUCCESS:
            return {
							...state,
							activeQueries: action.queries
						};
        case queryConstants.GET_ACTIVE_QUERY_REQUEST:
            return {isLoading: action.isLoading};
        case queryConstants.GET_ACTIVE_QUERY_FAILURE:
            return {hasErrored: action.hasErrored};

        case queryConstants.GET_INACTIVE_QUERY_SUCCESS:
            return {
							...state,
							inactiveQueries: action.queries
						};
        case queryConstants.GET_INACTIVE_QUERY_REQUEST:
            return {isLoading: action.isLoading};
        case queryConstants.GET_INACTIVE_QUERY_FAILURE:
            return {hasErrored: action.hasErrored};

        case queryConstants.POST_QUERY_SUCCESS:
            return state;
				case queryConstants.POST_QUERY_REQUEST:
            return {
							...state,
							loading: true
						};
				case queryConstants.POST_QUERY_FAILURE:
            return {error: action.error};
        case queryConstants.PUT_QUERY_SUCCESS:
            return state;
				case queryConstants.PUT_QUERY_REQUEST:
            return {
							...state,
							loading: true
						};
				case queryConstants.PUT_QUERY_FAILURE:
            return {error: action.error};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/queries.js